<template>
    <h1>About File Hero</h1>
    <div class="box center-800">
        <p>File Hero is a document management system for professionals in high-volume environments.</p>
        <p>There there is a growing need for better management tools and technologies that can help legal professionals
            streamline their workflows, increase collaboration, and improve productivity. These tools can include document
            management systems, case management software, and communication platforms that facilitate secure and efficient
            communication and collaboration.</p>
    </div>
</template>